export const editGridAddBtn = 'editGridAddBtn';
export const editGridRemoveBtn = 'editGridRemoveBtn';

export const cancelBtn = 'cancelBtn';
export const resetPasswordBtn = 'resetPasswordBtn';
export const saveBtn = 'saveBtn';
export const nextBtn = 'nextBtn';
export const previousBtn = 'previousBtn';
